module.exports = __webpack_public_path__ + "static/img/zanting2.18be4bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/zanting2.png
// module id = 29Xb
// module chunks = 24